import * as React from "react";
import { RES_URL } from "../../config";
import { Translation } from "../../models/models";
import { SocialButtons } from "../../components/ui/SocialButtons/SocialButtons";
import { Footer } from "../../components/ui/Footer/Footer";
import { LinkButton } from "../../components/ui/Button/Button";

export interface ProtanopiaPageProps {
  className?: string;
  locale: Translation;
}

export interface ProtanopiaPageState {}

export class ProtanopiaPage extends React.Component<
  ProtanopiaPageProps,
  ProtanopiaPageState
> {
  el: HTMLDivElement;
  constructor(props: ProtanopiaPageProps) {
    super(props);
  }

  render() {
    let cls = this.props.className || "";
    const currentLang = (window as any).__LOCALE__;
    let splashHtml = { __html: this.props.locale.protanopiaSplash };
  
    return (
      <div className={"protanopia-page" + cls} ref={e => (this.el = e)}>
        {(currentLang !== "en" && (
          <a
            href={this.props.locale.clientUrl}
            target="_blank"
            className="client-logo-container hide-on-embed"
          >
            <img
              src={RES_URL + "img/lenstore-logo-de.png"}
              alt="Kontaktlinsen mit schneller Lieferung nach Deutschland | Lenstore.de"
              className="client-logo"
            />
          </a>
        )) || (
          <a
            href={this.props.locale.clientUrl}
            target="_blank"
            className="client-logo-container hide-on-embed"
          >
            <img
              src={RES_URL + "img/lenstore-logo-uk.png"}
              alt="Contact Lenses with Fast UK Delivery | Lenstore.co.uk"
              className="client-logo"
            />
          </a>
        )}
        <div className="protanopia-page__content">
          {(currentLang !== "en" && (
            <a href="">
              <img
                className="protanopia-page__image"
                src={RES_URL + "img/colourchange-logo-de.png"}
                alt="Kontaktlinsen mit schneller Lieferung nach Deutschland | Lenstore.de"
              />
            </a>
          )) || (
            <a href="">
              <img
                className="protanopia-page__image"
                src={RES_URL + "img/colourchange-logo-uk.png"}
                alt="Contact Lenses with Fast UK Delivery | Lenstore.co.uk"
              />
            </a>
          )}
          <div
            className="protanopia-page__splash"
            dangerouslySetInnerHTML={splashHtml}
          />
          <LinkButton
            className="protanopia-page__button"
            href="#/protanopia/protanopia-kleukenhof-tulip-gardens"
          >
            {this.props.locale.exploreButton}
          </LinkButton>
        </div>
        <img
          className="campaign-wave"
          src={RES_URL + "img/desktop-wave-pro.png"}
          alt="Colour Change"
        />
        <Footer locale={this.props.locale} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProtanopiaPage/ProtanopiaPage.tsx